import { render, staticRenderFns } from "./VCurrency.vue?vue&type=template&id=7ddd76f9&scoped=true&"
import script from "./VCurrency.vue?vue&type=script&lang=js&"
export * from "./VCurrency.vue?vue&type=script&lang=js&"
import style0 from "./VCurrency.vue?vue&type=style&index=0&id=7ddd76f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddd76f9",
  null
  
)

export default component.exports